import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Spin, message, Tabs, Col, Input } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';

function FaqAddEdit() {
	const navigate = useNavigate();
	const { editFaqId } = useParams();
	const [isLoading, setIsLoading] = useState(false);
	const [form] = Form.useForm();

	const get = () => {
		if (!editFaqId) return;

		setIsLoading(true);
		axios
			.get(`/faq`, { params: { _id: editFaqId } })
			.then((result) => {
				if (Array.isArray(result.data.data) && result.data.data.length) {
					const [data] = result.data.data;
					form.setFieldsValue(data);
				}
			})
			.catch(() => {})
			.finally(() => setIsLoading(false));
	};

	const onSave = () => {
		form.validateFields()
			.then((values) => {
				setIsLoading(true);
				if (editFaqId) values._id = editFaqId;

				axios({
					method: editFaqId ? 'put' : 'post',
					url: '/faq',
					data: values,
				})
					.then((result) => {
						if (result.data.success) {
							message.success(result.data.message);
							navigate('/faq');
						} else {
							message.error(result.data.message);
							setIsLoading(false);
						}
					})
					.catch(() => {
						message.error('Oops! Something went wrong!');
						setIsLoading(false);
					});
			})
			.catch((e) => console.log(e));
	};

	useEffect(() => {
		get();
	}, []);

	return (
		<>
			<BreadCrumb
				breadcrumbs={[
					{ link: '/', label: 'Home' },
					{ link: '/faq', label: 'FAQ' },
				]}
			/>
			<Spin spinning={isLoading}>
				<div className='main-content'>
					<div className='page-header'>
						<div className='page-title'>{editFaqId ? 'Edit FAQ' : 'Add FAQ'}</div>
						<div className='page-title-more'>
							<Link to='/faq'>
								<Button icon={<ArrowLeftOutlined />}>Back</Button>
							</Link>
							<Button icon={<SaveOutlined />} type='primary' onClick={onSave} loading={isLoading}>
								Save
							</Button>
						</div>
					</div>

					<div className='form-content'>
						<Form form={form} layout='vertical' autoComplete='off'>
							<Tabs
								defaultActiveKey='1'
								items={[
									{
										key: 'Details',
										label: 'Details',
										children: (
											<>
												<Col sm={24} md={12}>
													<Form.Item label='Question' name='question' rules={[{ required: true, message: 'Question is required' }]}>
														<Input placeholder='Enter question' autoFocus />
													</Form.Item>
												</Col>

												<Col sm={24} md={24}>
													<Form.Item label='Answer' name='answer' rules={[{ required: true, message: 'Answer is required' }]}>
														<Input.TextArea rows={6} placeholder='Enter answer' />
													</Form.Item>
												</Col>
											</>
										),
									},
								]}
							/>
						</Form>
					</div>
				</div>
			</Spin>
		</>
	);
}

export default FaqAddEdit;
